import { compose } from 'redux';
import { useCallback } from 'react';
import { connect } from 'react-redux';

import { getActionDataStateFromState } from 'app/app.selectors';
import { TEAM_ACTIONS } from 'features/projects/team/team.constants';
import { addUsersToProject } from 'features/projects/team/team.actions';
import useCurrentProject from 'features/projects/hooks/useCurrentProject';

import CreateProjectMembersModal from 'features/projects/team/components/CreateProjectMembersModal';

const CreateProjectMembersModalContainer = ({
  users,
  isOpen,
  title,
  projectId,
  dataState,
  toggleModal,
  projectMembers,
  teamProjectRoles,
  dispatchAddUsersToProject,
}) => {
  const project = useCurrentProject();

  const addSelectedUsersToProject = useCallback(
    (users) => dispatchAddUsersToProject(projectId, users).then(toggleModal),
    [projectId, toggleModal, dispatchAddUsersToProject],
  );

  return (
    <CreateProjectMembersModal
      users={users}
      isOpen={isOpen}
      title={title}
      project={project}
      dataState={dataState}
      toggleModal={toggleModal}
      projectMembers={projectMembers}
      teamProjectRoles={teamProjectRoles}
      addUsersToProject={addSelectedUsersToProject}
    />
  );
};

export default compose(
  connect(
    (state) => ({
      dataState: getActionDataStateFromState(
        state,
        TEAM_ACTIONS.ADD_PROJECT_MEMBERS,
      ),
    }),
    {
      dispatchAddUsersToProject: addUsersToProject,
    },
  ),
)(CreateProjectMembersModalContainer);
